// @router
import { RouteConfig } from "vue-router";

export const researchRoutes: RouteConfig[] = [
  {
    path: "/new-research",
    name: "dynamic_home",
    meta: {
      label: "خانه",
      requiresAuth: true,
      deprecated: true,
    },
    // component: newContainer,
    children: [
      {
        path: "assign-research-manager-to-researcher",
        name: "assign_research_manager_to_researcher",
        meta: {
          label: "تحقیق",
          requiresAuth: true,
          deprecated: true,
        },
        redirect: "/new-research/assign-research-manager-to-researcher/list",
        // component: routerParrent,
        children: [
          {
            path: "list",
            name: "assign-research-manager-to-researcher-list",
            // component: researchManagerResearcher,
            meta: {
              label: "ارتباط مدیر تحقیق با ارزیاب تحقیقات",
              requiresAuth: true,
              deprecated: true,
            },
          },
        ],
      },
      {
        path: "ready-research",
        name: "ready_research",
        meta: {
          label: "تحقیق",
          requiresAuth: true,
          deprecated: true,
        },
        redirect: "/new-research/ready-research/list",
        // component: routerParrent,
        children: [
          {
            path: "list",
            name: "ready-research-list",
            // component: researchManagerConnectionSearch,
            meta: {
              label: "آماده تحقیق",
              requiresAuth: true,
              deprecated: true,
            },
          },
        ],
      },
      {
        path: "my_research",
        name: "my_research",
        meta: {
          label: "تحقیقات من",
          requiresAuth: true,
          deprecated: true,
        },
        redirect: "/new-research/my_research/search",
        // component: routerParrent,
        children: [
          {
            path: "search",
            name: "my_research_queue",
            // component: myResearchesList,
            meta: {
              label: "لیست تحقیقات من",
              requiresAuth: true,
              deprecated: true,
            },
          },
        ],
      },
      {
        path: "inner_research",
        name: "research_queue",
        meta: {
          label: "تحقیق",
          requiresAuth: true,
          deprecated: true,
        },
        redirect: "/new-research/inner_research/search",
        // component: routerParrent,
        children: [
          {
            path: "search",
            name: "search",
            // component: researchSearch,
            meta: {
              // label: "ارتباط مدیر تحقیق با ارزیاب تحقیقات",
              requiresAuth: true,
              deprecated: true,
              hasMaxWidth: false,
            },
          },
          {
            path: "researchPlan/:code",
            name: "research_plan_search",
            // component: editSearch,
            meta: {
              label: "عملیات تحقیق",
              deprecated: true,
              requiresAuth: true,
            },
          },
        ],
      },
      {
        path: "my_researcher",
        name: "researcher",
        meta: {
          label: "ارزیاب های من",
          requiresAuth: true,
          deprecated: true,
        },
        redirect: "/new-research/my_researcher/search",
        children: [
          {
            path: "search",
            name: "my_researcher",
            meta: {
              label: "ارزیاب های من",
              requiresAuth: true,
              deprecated: true,
            },
          },
        ],
      },
    ],
  },
];
